import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import fr from "vee-validate/dist/locale/fr";

Vue.use(VeeValidate);

const tras = {
    name: "fr",
    messages: {
        _default: function(e) {
            return "Invalide";
        },
        after: function(e, t) {
            return "Dit être postérieur à " + t[0] + ".";
        },
        alpha: function(e) {
            return "Ne peut contenir que des lettres.";
        },
        alpha_dash: function(e) {
            return "Ne peut contenir que des caractères alpha-numériques, tirets ou soulignés.";
        },
        alpha_num: function(e) {
            return "Ne peut contenir que des caractères alpha-numériques.";
        },
        alpha_spaces: function(e) {
            return "Ne peut contenir que des lettres ou des espaces.";
        },
        before: function(e, t) {
            return "Doit être antérieur à " + t[0] + ".";
        },
        between: function(e, t) {
            return (
                "Doit être compris entre " +
                t[0] +
                " et " +
                t[1] +
                "."
            );
        },
        confirmed: function(e, t) {
            return "Ne correspond pas à " + t[0] + ".";
        },
        credit_card: function(e) {
            return "Invalide.";
        },
        date_between: function(e, t) {
            return (
                "Doit être situé entre " + t[0] + " et " + t[1] + "."
            );
        },
        date_format: function(e, t) {
            return "Doit être au format " + t[0] + ".";
        },
        decimal: function(e, t) {
            void 0 === t && (t = []);
            var n = t[0];
            return (
                void 0 === n && (n = "*"),
                "Doit être un nombre et peut contenir " +
                ("*" === n ? "des" : n) +
                " décimales."
            );
        },
        digits: function(e, t) {
            return (
                "Doit être un nombre entier de " +
                t[0] +
                " chiffres."
            );
        },
        dimensions: function(e, t) {
            return (
                "Doit avoir une taille de " +
                t[0] +
                " pixels par " +
                t[1] +
                " pixels."
            );
        },
        email: function(e) {
            return "Doit être une adresse e-mail valide.";
        },
        excluded: function(e) {
            return "Doit être une valeur valide.";
        },
        ext: function(e) {
            return "Doit être un fichier valide.";
        },
        image: function(e) {
            return "Doit être une image.";
        },
        included: function(e) {
            return "Doit être une valeur valide.";
        },
        integer: function(e) {
            return "Doit être un entier.";
        },
        ip: function(e) {
            return "Doit être une adresse IP.";
        },
        length: function(e, t) {
            var n = t[0],
                r = t[1];
            return r
                ? "Doit contenir entre " +
                n +
                " et " +
                r +
                " caractères."
                : "Le champ " + e + " doit contenir " + n + " caractères.";
        },
        max: function(e, t) {
            return (
                "Ne peut pas contenir plus de " +
                t[0] +
                " caractères."
            );
        },
        max_value: function(e, t) {
            return (
                "Doit avoir une valeur de " + t[0] + " ou moins."
            );
        },
        mimes: function(e) {
            return "Doit avoir un type MIME valide.";
        },
        min: function(e, t) {
            return (
                "Doit contenir au minimum " + t[0] + " caractères."
            );
        },
        min_value: function(e, t) {
            return (
                "Doit avoir une valeur de " + t[0] + " ou plus."
            );
        },
        numeric: function(e) {
            return "Ne peut contenir que des chiffres.";
        },
        regex: function(e) {
            return "Invalide";
        },
        required: function(e) {
            return "Obligatoire";
        },
        size: function(e, t) {
            var n,
                r,
                i,
                a = t[0];
            return (
                "Doit avoir un poids inférieur à " +
                ((n = a),
                    (r = 1024),
                    (i =
                        0 == (n = Number(n) * r) ? 0 : Math.floor(Math.log(n) / Math.log(r))),
                1 * (n / Math.pow(r, i)).toFixed(2) +
                " " +
                ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][i]) +
                "."
            );
        },
        url: function(e) {
            return "N'est pas une URL valide.";
        }
    },
    attributes: {}
};

Validator.localize("fr", tras);
